
export default function Problem() {
  const problems = [
    {
      icon: 'ri-time-line',
      title: 'Taking Any Job to Survive',
      description: 'You say yes to everything because you need the work—even when it\'s low-margin and stressful.'
    },
    {
      icon: 'ri-question-line',
      title: 'No Idea What\'s Working',
      description: 'Your website and Google profile exist, but you have no clue if they\'re actually bringing in customers.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Competitors Get the Good Jobs',
      description: 'Other businesses seem to attract premium clients effortlessly. Why not you?'
    }
  ];

  return (
    <section className="bg-[#1A1F36] py-24 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#FF6B35]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#FF6B35]/3 rounded-full blur-2xl"></div>
      
      <div className="max-w-[1200px] mx-auto px-6 relative">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left side - Headline */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 border border-white/10 rounded-full text-sm mb-6">
              <span className="w-1.5 h-1.5 bg-[#FF6B35] rounded-full"></span>
              <span className="text-white/80 font-medium">Sound Familiar?</span>
            </div>
            <h2 className="text-4xl lg:text-[48px] font-bold text-white leading-tight mb-6">
              You're Busy.<br />
              But Are You <span className="text-[#FF6B35]">Getting Ahead?</span>
            </h2>
            <p className="text-lg text-white/60 max-w-[400px]">
              Most service businesses face the same challenges. The good news? They're all fixable.
            </p>
          </div>

          {/* Right side - Problem list */}
          <div className="space-y-4">
            {problems.map((problem, index) => (
              <div 
                key={index}
                className="group flex items-start gap-5 bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-[#FF6B35]/40 hover:bg-white/10 transition-all duration-300"
              >
                <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl border border-[#FF6B35]/20 group-hover:bg-[#FF6B35]/20 transition-all duration-300">
                  <i className={`${problem.icon} text-2xl text-[#FF6B35]`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-1.5">
                    {problem.title}
                  </h3>
                  <p className="text-base text-white/60 leading-relaxed">
                    {problem.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
